var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 3.33331V18.3333M10.8334 6.66665H12.5001M10.8334 9.99998H12.5001M5.00008 3.33331H14.1667C14.6088 3.33331 15.0327 3.50891 15.3453 3.82147C15.6578 4.13403 15.8334 4.55795 15.8334 4.99998V15C15.8334 15.442 15.6578 15.8659 15.3453 16.1785C15.0327 16.4911 14.6088 16.6666 14.1667 16.6666H5.00008C4.77907 16.6666 4.56711 16.5789 4.41083 16.4226C4.25455 16.2663 4.16675 16.0543 4.16675 15.8333V4.16665C4.16675 3.94563 4.25455 3.73367 4.41083 3.57739C4.56711 3.42111 4.77907 3.33331 5.00008 3.33331Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.8c940b00d9f46479489922856cbb9a9c.svg";
export { ForwardRef as ReactComponent };